import { render } from "./VideoNew.vue?vue&type=template&id=81b1c450&scoped=true"
import script from "./VideoNew.vue?vue&type=script&lang=js"
export * from "./VideoNew.vue?vue&type=script&lang=js"

import "./VideoNew.vue?vue&type=style&index=0&id=81b1c450&scoped=true&lang=css"
import "./VideoNew.vue?vue&type=style&index=1&id=81b1c450&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b1c450"]])

export default __exports__